import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  Button,
} from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function DeleteGroupConfirm({ open, groupName, onClose, onConfirm, loading }) {
  const { t } = useScriptMode();
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (!open) setTyped("");
  }, [open]);

  const matches = !!groupName && typed === groupName;

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t("manage_delete_group_modal_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("manage_delete_group_modal_body")}</DialogContentText>
        <TextField
          fullWidth
          label={t("manage_delete_group_input_label")}
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          margin="normal"
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t("manage_delete_group_cancel")}
        </Button>
        <Button
          color="error"
          variant="contained"
          disabled={!matches || loading}
          onClick={onConfirm}
        >
          {t("manage_delete_group_confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
